import React, { ReactElement } from 'react';
import CommonCard from './CommonCard';
import Panel from '../../../shared/components/card/Panel';

const DiagnosisCard = (props: any): ReactElement => {
  const { detail: { transactionList = [] } } = props || {};
  return (
    transactionList?.map((data: any, index: number): any => (
      <Panel className="cardclass" key={index + '' + data?.transactionId}>
        <h2>
          <strong>{data?.requesterHospitalName || '-'}</strong>
        </h2>
        {
          data?.finalFhirObjectsToDisplay?.map((dataOfThisTransactionId: any, id: number): any => (
            <CommonCard key={Date.now().toString() + id} data={dataOfThisTransactionId} />
          ))
        }
      </Panel>
    ))
  );
};
export default DiagnosisCard;
